import { Secret, GameState } from 'game-logic';
import { SolitaireListener } from '../solitaire-listener';

export class GameListenerService implements SolitaireListener {
  private gameListenerService?: SolitaireListener;

  public setSolitaireListener(solitaireListener: SolitaireListener) {
    this.gameListenerService = solitaireListener;
  }

  onGameLoaded(): void {
    this.gameListenerService?.onGameLoaded();
  }
  onStartGame(): void {
    this.gameListenerService?.onStartGame();
  }
  onScoreChange(score: number): void {
    this.gameListenerService?.onScoreChange(score);
  }
  onNewMove(moves: string[]): void {
    this.gameListenerService?.onNewMove(moves);
  }
  onGameStateChange(state: GameState): void {
    this.gameListenerService?.onGameStateChange(state);
  }
  onGameComplete(moves: string[], isComplete: boolean): void {
    this.gameListenerService?.onGameComplete(moves, isComplete);
  }
  showNoMoreHintsPopup(): void {
    this.gameListenerService?.showNoMoreHintsPopup();
  }
  discloseSecrets(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<Secret[]> {
    return (
      this.gameListenerService?.discloseSecrets(
        indexes,
        gameHash,
        disclosedSecrets,
        existingDeal,
      ) ?? Promise.resolve([])
    );
  }
}
